// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-container[data-v-3d1001c2]{display:flex;justify-content:center;align-items:center;min-height:80vh;flex-direction:column}[dir] .pay-container[data-v-3d1001c2]{text-align:center;padding:20px}.error-message h1[data-v-3d1001c2]{color:red}button[data-v-3d1001c2]{font-size:16px}[dir] button[data-v-3d1001c2]{margin:20px;padding:10px 20px}.contact a[data-v-3d1001c2]{color:#00f;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
